export default __webpack_public_path__ + "static/media/03-hole-cx.4359b980.png";